// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__3IBWs","skillContainer":"Skills_skillContainer__4FatT"};